import React from "react";
import NoData from "../../../../../components/noData/noData";
import CommonTable from "../../../../../components/table/table";
import useCommonFetch from "../../../../../../hooks/useCommonFetch";
import { getPurchaseOrderList } from "../../../../../../services/workspace/inventory.service";

const PurchaseOrderCard = ({ id }) => {

  const customCase = {
  0: { label: "Pending", color: "text-yellow-500 text-sm", bg: "bg-yellow-500" },
  1: { label: "Completed", color: "text-green-600 text-sm", bg: "bg-green-600" },
  2: { label: "Cancelled", color: "text-red-500 text-sm", bg: "bg-red-600" },
  }

  const paymentCustomCase = {
  "Partially Paid": { label: "Partically Paid", color: "text-Yellow-500 text-sm", bg: "bg-Yellow-500" },
  "Paid": { label: "Paid", color: "text-green-600 text-sm", bg: "bg-green-600" },
  "Unpaid": { label: "Unpaid", color: "text-red-500 text-sm", bg: "bg-red-600" },
  }

  const {
    loading,
    data: tableData,
    total: totalData,
    currentPage,
    search,
    // selectedId,
    action,
    handleSearchChange,
    handlePageChange,
    openModal,
    closeModal,
    handleCreate,
    handleUpdate,
    handleDelete,
    fetchData,
    softDelete,
    // New sorting helpers
    sortingUIProps,
  } = useCommonFetch(getPurchaseOrderList, {
 
    dataPath: "purchaseOrder.data",
    totalPath: "purchaseOrder.meta.total",
    errorMessage: "Failed to fetch purchase order data!",
    debounceDelay: 500,
    customParams: {
      with: "vendor,createdBy,stockItems",
      vendor_id:id
    },

    // Add data transformer function
    dataTransformer: (data) => {
      if (Array.isArray(data)) {
        const transformedData = data.map((item, index) => ({
          ...item,
          // Add custom fields or modify existing ones
          id: {
            data: item.id,
            className: "",
            sticky: false,
            variant: "text",
          },
          uuid: {
            data: item.uuid,
            className: "",
            sticky: false,
            variant: "text",
          },
          code: {
            data: item?.code,
            className: "",
            sticky: false,
            variant: "name",
          },

          priority: {
            data:
              item.priority === 0
                ? "Low"
                : item.priority === 1
                ? "Medium"
                : "High",
            className: "",
            sticky: false,
            variant: "text",
          },
          expected_date: {
            data: item.expected_date,
            className: "",
            sticky: false,
            variant: "date",
          },
          name: {
            data: item.vendor.name,
            className: "",
            sticky: false,
            variant: "text",
          },
          created_at: {
            data: item.created_at,
            className: "",
            sticky: false,
            variant: "date",
          },

          payment_status: {
            data: item.payment_status,
            className: "",
            sticky: false,
            variant: "status",
            customCases: paymentCustomCase,
          },
          order_status:{
            data: item.status,
            className: "",
            sticky: false,
            variant: "status",
            customCases: customCase,
          },
          actions: {
            data: item.id,
            className: "",
            sticky: false,
            variant: "text",
          },
        }));

        return {
          data: transformedData,
        };
      }
      return { data: [], action: {} };
    },
  });

  const TableHeaderData = [
    {
      label: "Purchase Order No.",
      key: "code",
    },
    {
      label: "Issued Date",
      key: "created_at",
    },
    {
      label: "Expected Date",
      key: "expected_date",
    },
    {
      label: "Amount",
      key: "total_amount",
    },
    {
      label: "Priority",
      key: "priority",
    },
    {
      label: "Payment Status",
      key: "payment_status",
    },
    {
      label: "Status",
      key: "order_status",
    },
  ];

  if (!tableData) {
    return (
      <p className="text-gray-500 p-4 bg-white rounded-md">
        <NoData
          title="No Result Found"
          message="Please try again with another keywords or maybe use generic term"
          buttonText={null}
        />
      </p>
    );
  }

  return (
    <div className="flex flex-col gap-4 rounded-md ">
      <CommonTable
        search={search}
        TableHeaderData={TableHeaderData}
        tabledata={tableData.data}
        currentPage={currentPage}
        totalData={totalData}
        setCurrentPage={handlePageChange}
        loading={loading}
        action={tableData.action}
      />
    </div>
  );
};

export default PurchaseOrderCard;
